<template>
  <div>
    <document-register />
    <router-view />
  </div>
</template>

<script>
import DocumentRegister from './DocumentRegister.vue'

export default {
  name: 'RegisterDocuments',
  components: {
    DocumentRegister
  }
}
</script>
<style></style>
